/**
 * Thai labels for the 5 seeded roles. The DB keeps English `name` as the
 * canonical value (used in API responses + audit logs) — this helper only
 * shapes the display text for admin UI surfaces (/roles, /users,
 * header dropdown, dashboard widgets, account page, banners).
 *
 * Keyed by both slug AND English name so callers can pass either:
 *   roleLabelTh('super_admin')  → 'ผู้ดูแลระบบสูงสุด'
 *   roleLabelTh('Super Admin')  → 'ผู้ดูแลระบบสูงสุด'
 * Unknown values fall through unchanged so a freshly-renamed/custom role
 * still shows its English name instead of an empty cell.
 */

const ROLE_LABELS_TH: Record<string, string> = {
  // by slug
  super_admin: 'ผู้ดูแลระบบสูงสุด',
  admin: 'ผู้ดูแลระบบ',
  editor: 'บรรณาธิการ',
  author: 'นักเขียน',
  contributor: 'ผู้ร่วมเขียน',
  // by English name (case-insensitive lookup via .toLowerCase below)
  'super admin': 'ผู้ดูแลระบบสูงสุด',
};

export function roleLabelTh(slugOrName: string | null | undefined): string {
  if (!slugOrName) return '';
  return ROLE_LABELS_TH[slugOrName.toLowerCase()] ?? slugOrName;
}
